module.exports = __webpack_public_path__ + "static/media/vector-share-google.3f8eb852.png";